import { render, staticRenderFns } from "./WechatPay.vue?vue&type=template&id=908c319a&scoped=true&"
import script from "./wechatpay.js?vue&type=script&lang=js&"
export * from "./wechatpay.js?vue&type=script&lang=js&"
import style0 from "./WechatPay.vue?vue&type=style&index=0&id=908c319a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "908c319a",
  null
  
)

export default component.exports